<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">

        <el-form-item label="活动类型" required>
          <el-select v-model="form.type_id" placeholder="请选择" :disabled="type=='update'">
            <el-option
                v-for="item in form.type_list"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="体验营类型标题" required>
          <el-input size="medium" v-model="form.title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="体验营主题图" required>
          <activityCustomUpload :formName="'img_url'" :formValue="form.img_url"
                                @uploadSuccess="uploadSuccess"></activityCustomUpload>
        </el-form-item>


        <el-form-item>
          <template v-if="type == 'create'">
            <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">立即创建</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onUpdate" :loading="onSubmitLoading">保存</el-button>
          </template>

          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import {typeInfo, createCampType, updateCampType} from "@/api/activityCamp";

export default {
  components: {activityCustomUpload},
  data: function () {
    return {
      id: '',
      type: 'create',
      form: {
        activity_camp_id:'',
        title:'',
        img_url:''
      },
      typeListData:[],
      onSubmitLoading: false,
      formLoading: false,
    };
  },
  created: function () {
    this.type = this.$route.query.type
    if (this.type == 'update') {
      this.id = this.$route.query.id;
    }else{
      this.form.activity_camp_id = this.$route.query.id;
    }
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      typeInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false;
        this.form.type_list = response.data.type_list;
        if(this.type == 'update'){
          this.form.type_id = response.data.type_id;
          this.form.title = response.data.title;
          this.form.img_url = response.data.img_url;
          this.form.id = response.data.id;
        }
      });
    },
    uploadSuccess(value) {
      this.$set(this.form, value.formName, value.fileUrl)
    },
    onUpdate() {
      this.onSubmitLoading = true;
      updateCampType(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    onSubmit() {
      this.onSubmitLoading = true;
      createCampType(this.form).then((res) => {
        this.onSubmitLoading = false;
        if (res.code == 1) {
          this.form = {}
          this.$message({
            showClose: true,
            duration: 6000,
            message: '创建成功',
            type: 'success'
          });
          this.backPrePage();
        }
      });
    },
    backPrePage() {
      this.$router.go(-1);
    },
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}
.product-img{
  width: 80px;
  height: 80px;
  margin: 0 10px 0 0;
}
</style>

